<template>
  <div class="warehouse-outbound-list-container">
    <!-- 顶部标题栏 -->
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>出库明细表</span>
      </div>
    </div>
    
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-date-picker
        v-model="startDate"
        type="date"
        placeholder="查询时间起"
        aria-label="查询时间起"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input date-picker"
      ></el-date-picker>
      <el-date-picker
        v-model="endDate"
        type="date"
        placeholder="查询时间止"
        aria-label="查询时间止"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input date-picker"
      ></el-date-picker>
      
      <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
      <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
    </div>
    
    <!-- 出库明细列表 -->
    <el-table
      :data="outboundList"
      border
      style="width: 100%"
      v-loading="loading"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
    >
      <el-table-column
        type="index"
        label="序号"
        width="60"
        align="center"
        :index="indexMethod"
      ></el-table-column>
      
      <el-table-column
        label="出库时间"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.outboundTime) }}
        </template>
      </el-table-column>
      
      <el-table-column
        label="库房名称"
        min-width="150"
        align="center"
        header-align="center"
        :header-cell-style="{ background: '#fffbe6', color: '#606266' }"
      >
        <template slot-scope="scope">
          <span class="warehouse-name">{{ scope.row.warehouseName || '-' }}</span>
        </template>
      </el-table-column>
      
      <el-table-column
        label="材料名称"
        min-width="200"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.materialName || '-' }}
        </template>
      </el-table-column>
      
      <el-table-column
        label="规格型号"
        min-width="150"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.specification || '-' }}
        </template>
      </el-table-column>
      
      <el-table-column
        label="单位"
        width="80"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.unit || '-' }}
        </template>
      </el-table-column>
      
      <el-table-column
        label="含税单价"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.unitPriceWithTax !== undefined && scope.row.unitPriceWithTax !== null">
            {{ formatUnitPrice(scope.row.unitPriceWithTax) }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      
      <el-table-column
        label="不含税单价"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.unitPriceWithoutTax !== undefined && scope.row.unitPriceWithoutTax !== null">
            {{ formatUnitPrice(scope.row.unitPriceWithoutTax) }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      
      <el-table-column label="本期出库" align="center">
        <el-table-column
          label="数量"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.quantity || 0 }}
          </template>
        </el-table-column>
        
        <el-table-column
          label="金额 (含税)"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.amountWithTax !== undefined && scope.row.amountWithTax !== null">
              {{ formatAmount(scope.row.amountWithTax) }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        
        <el-table-column
          label="金额 (不含税)"
          width="130"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.amountWithoutTax !== undefined && scope.row.amountWithoutTax !== null">
              {{ formatAmount(scope.row.amountWithoutTax) }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table-column>
      
      <el-table-column
        label="销售单位"
        min-width="200"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.salesUnitName || '-' }}
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <el-pagination
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
      :current-page="pagination.current"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      class="pagination-container"
    ></el-pagination>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'WarehouseOutboundList',
  data() {
    return {
      // 独立起止日期
      startDate: '',
      endDate: '',
      // 表格加载状态
      loading: false,
      // 出库明细列表数据
      outboundList: [],
      // 分页参数
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    // 初始加载数据
    this.loadData()
  },
  methods: {
    // 计算序号
    indexMethod(index) {
      return (this.pagination.current - 1) * this.pagination.pageSize + index + 1
    },
    
    // 格式化日期时间
    formatDateTime(date) {
      return date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    
    // 格式化日期
    formatDate(date) {
      return date ? moment(date).format('YYYY-MM-DD') : '-'
    },

    // 格式化金额（带千位分隔符）
    formatAmount(amount) {
      if (amount === undefined || amount === null) return '0.00';
      return Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    // 格式化单价（不带千位分隔符）
    formatUnitPrice(amount) {
      if (amount === undefined || amount === null) return '0.00';
      return Number(amount).toFixed(2);
    },
    
    // 搜索
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    
    // 重置
    handleReset() {
      this.startDate = ''
      this.endDate = ''
      this.pagination.current = 1
      this.loadData()
    },
    
    // 页码变化
    handlePageChange(page) {
      this.pagination.current = page
      this.loadData()
    },
    
    // 每页条数变化
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.current = 1
      this.loadData()
    },
    
    // 加载数据（demo数据，暂不调用后台接口）
    loadData() {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        this.$message.warning('查询时间起不能晚于查询时间止')
        return
      }
      this.loading = true
      
      // 模拟API调用延迟
      setTimeout(() => {
        // 生成模拟数据
        const mockData = this.generateMockData()
        
        // 根据日期范围过滤数据
        let filteredData = mockData
        if (this.startDate || this.endDate) {
          const startDate = this.startDate ? moment(this.startDate).startOf('day') : null
          const endDate = this.endDate ? moment(this.endDate).endOf('day') : null
          filteredData = mockData.filter(item => {
            const outboundTime = moment(item.outboundTime)
            return (!startDate || !outboundTime.isBefore(startDate)) &&
                   (!endDate || !outboundTime.isAfter(endDate))
          })
        }
        
        // 分页处理
        const start = (this.pagination.current - 1) * this.pagination.pageSize
        const end = start + this.pagination.pageSize
        this.outboundList = filteredData.slice(start, end)
        this.pagination.total = filteredData.length
        
        this.loading = false
      }, 500)
    },
    
    // 生成模拟数据
    generateMockData() {
      const warehouses = ['主仓库', '原料仓库', '成品仓库', '配件仓库']
      const materials = ['钢材', '水泥', '木材', '砖块', '沙子', '石子', '钢筋', '混凝土']
      const specifications = ['规格A', '规格B', '规格C', '规格D', '标准型', '加强型']
      const units = ['吨', '立方米', '件', '箱', '包']
      const salesUnits = ['销售单位A', '销售单位B', '销售单位C', '销售单位D', '销售单位E']
      
      const data = []
      const today = moment()
      
      // 生成100条模拟数据
      for (let i = 0; i < 100; i++) {
        const outboundTime = moment(today).subtract(Math.floor(Math.random() * 90), 'days')
        const quantity = Math.floor(Math.random() * 1000) + 10
        const unitPriceWithTax = Math.random() * 1000 + 50
        const unitPriceWithoutTax = unitPriceWithTax / 1.13 // 假设税率13%
        const amountWithTax = quantity * unitPriceWithTax
        const amountWithoutTax = quantity * unitPriceWithoutTax
        
        data.push({
          id: i + 1,
          outboundTime: outboundTime.format('YYYY-MM-DD HH:mm:ss'),
          warehouseName: warehouses[Math.floor(Math.random() * warehouses.length)],
          materialName: materials[Math.floor(Math.random() * materials.length)],
          specification: specifications[Math.floor(Math.random() * specifications.length)],
          unit: units[Math.floor(Math.random() * units.length)],
          unitPriceWithTax: parseFloat(unitPriceWithTax.toFixed(2)),
          unitPriceWithoutTax: parseFloat(unitPriceWithoutTax.toFixed(2)),
          quantity: quantity,
          amountWithTax: parseFloat(amountWithTax.toFixed(2)),
          amountWithoutTax: parseFloat(amountWithoutTax.toFixed(2)),
          salesUnitName: salesUnits[Math.floor(Math.random() * salesUnits.length)]
        })
      }
      
      // 按出库时间倒序排列
      return data.sort((a, b) => moment(b.outboundTime).valueOf() - moment(a.outboundTime).valueOf())
    }
  }
}
</script>

<style scoped>
.warehouse-outbound-list-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.header-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.title-mark {
  width: 4px;
  height: 18px;
  background: #409EFF;
  margin-right: 10px;
}

.search-area {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  align-items: center;
}

.search-input {
  width: 200px;
}

.date-picker {
  width: 200px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

/* 库房名称高亮样式 */
.warehouse-name {
  font-weight: bold;
  color: #606266;
  background-color: #fffbe6;
  padding: 2px 8px;
  border-radius: 3px;
  display: inline-block;
}

/* 表格样式优化 */
::v-deep .el-table th {
  background-color: #f5f7fa !important;
  color: #606266 !important;
  font-weight: 600;
}

::v-deep .el-table .warehouse-name {
  font-weight: bold;
  color: #606266;
  background-color: #fffbe6;
  padding: 2px 8px;
  border-radius: 3px;
}
</style>

